module.exports = __webpack_public_path__ + "static/media/cv.624a2d4d.svg";